import { maxWidth600 } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"

export const styles = {
  itemSelected: (theme) => ({
    backgroundColor: theme.palette.background.notes,
  }),
  item: (theme) => ({
    height: 60,
    width: 250,
    borderBottom: `2px solid #ccc`,
    cursor: "pointer",
    position: "relative",
    [maxWidth600]: {
      // width: 230,
      minWidth: 200,
    },
  }),
  title: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
    width: "100%",
    lineHeight: "30px",
    fontSize: 14,
    textAlign: "center",
  },
  date: {
    color: theme.palette.grey[500],
    fontSize: 10,
    width: "100%",
    lineHeight: "30px",
    textAlign: "center",
  },
  icon: (theme) => ({
    position: "absolute",
    color: theme.palette.primary.main,
    left: "4%",
    top: "33%",
    fontSize: 18,
  }),
}
